module.exports = __webpack_public_path__ + "53d9c53f86a84aacd30a34f1c5cb5f5a.png";